let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Ure5z")).then(() => parcelRequire('bpdtz'));